import React, { useEffect, useState } from 'react';

import nexo from '../../nexoClient';

import { Page, Layout, FormField } from '@nimbus-ds/patterns';
import {
  Box,
  Button,
  Card,
  Icon,
  Spinner,
  List,
  useToast,
  Input,
  Text,
  Label,
  Select,
  Title,
} from '@nimbus-ds/components';
import { CogIcon, LockOpenIcon, UserIcon } from '@nimbus-ds/icons';
import { navigateHeader } from '@tiendanube/nexo/helpers';
import { useHistory } from 'react-router-dom';
import { Table } from '@nimbus-ds/components';
import axiosInstance from '../../axios';

const headersInactivos = [
  'Id',
  'Nombre',
  'Url',
  'Email',
  'Teléfono',
  'Fecha alta',
  'Acciones',
];
const headersAprobados = [
  'Id',
  'Nombre',
  'Url',
  'Email',
  'Teléfono',
  'Fecha aprobado',
  'Acciones',
];

const SetupPage: React.FC = () => {
  const { push } = useHistory();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [isVerifing, setIsVerifing] = useState(false);
  const [isVinculate, setIsVinculate] = useState(false);
  const [showMessageVinculateAccount, setShowMessageVinculateAccount] =
    useState(false);
  const [error, setError] = useState(false);
  const [user, setUser] = useState({
    usuario_api: '',
    access_key: '',
  });
  const [inactiveCustomers, setInactiveCustomers] = useState<Customer[]>([]);
  const [approvedCustomers, setApprovedCustomers] = useState<Customer[]>([]);

  const [currentApprovedCustomerPage, setCurrentApprovedCustomerPage] =
    useState(1);
  const [lastApprovedCustomerPage, setLastApprovedCustomerPage] = useState(1);
  const [loadingApprovedCustomers, setLoadingApprovedCustomers] =
    useState(false);

  interface Customer {
    tn_id: string;
    name: string;
    email: string;
    phone: string | null;
    status: string;
    tn_created_at: string | null;
    approved_at: string | null;
  }
  useEffect(() => {
    navigateHeader(nexo, { goTo: '/', text: 'Volver al inicio' });
  }, []);

  useEffect(() => {
    //checkVinculateAccount();
    getListOfInactiveCustomers();
  }, []);

  useEffect(() => {
    getListOfApprovedCustomers(currentApprovedCustomerPage);
  }, [currentApprovedCustomerPage]);

  const handleGoToDashboard = async () => {
    push('/');
  };

  const handleGoToConfig = async () => {
    push('/config');
  };

  const handleGoToRejected = async () => {
    push('/rejected');
  };

  const handleChange = (e: any) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  /*
  const getDashboard = async () => {
    try {
      const r = await axiosInstance.get('/dashboard');
      console.log(r);
    } catch (e) {
      console.error(e);
    }
    return;
  };
  getDashboard();
  */

  /*
  const getListOfPendingCustomers = async () => {
    console.log('obteniendo customers pendientes...');
    try {
      const response = await axiosInstance.get('/pending_customers_list');
      console.log(response);
      if (response.data.status) {
        console.log(response.data.customers);
        setPendingCustomers(response.data.customers);
      }
    } catch (e) {
      console.error(e);
    }
  };
  */

  const getListOfApprovedCustomers = async (page = 1) => {
    console.log('obteniendo customers activos...');
    setLoadingApprovedCustomers(true);
    try {
      const response = await axiosInstance.get('/approved_customers_list', {
        params: {
          page: page,
          perPage: 10,
        },
      });

      if (response.data.status) {
        setApprovedCustomers(response.data.customers);
        setCurrentApprovedCustomerPage(response.data.pagination.currentPage);
        setLastApprovedCustomerPage(response.data.pagination.lastPage);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingApprovedCustomers(false);
    }
  };

  const getListOfInactiveCustomers = async () => {
    console.log('obteniendo customers aprobados...');
    try {
      const response = await axiosInstance.get('/inactive_customers_list');
      console.log(response);
      if (response.data.status) {
        console.log(response.data.customers);
        setInactiveCustomers(response.data.customers);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleFilterInactive = async (e: any) => {
    console.log(e.target.value);
    try {
      const response = await axiosInstance.get('/inactive_customers_filter', {
        params: {
          filter: e.target.value,
        },
      });
      console.log(response);
      if (response.data.status) {
        console.log(response.data.customers);
        setInactiveCustomers(response.data.customers);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleFilterAprobados = async (e: any) => {
    console.log(e.target.value);
    try {
      const response = await axiosInstance.get('/approved_customers_filter', {
        params: {
          filter: e.target.value,
        },
      });
      console.log(response);
      if (response.data.status) {
        console.log(response.data.customers);
        setApprovedCustomers(response.data.customers);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleSellerStatusChange = (e: any) => {
    console.log(e.target.value, ' - ', e.target.key, ' - ', e.target.label);
    console.log(e.target.id);
    console.log(e.key);
  };

  const makeInactiveCustomer = async (tn_id: any) => {
    console.log('make inactive customer customer id : ' + tn_id);
    /*
    const customer = pendingCustomers.find((c) => c.tn_id == tn_id);
    if (!customer) {
      addToast({
        id: 'approve-customer-tag-fail',
        type: 'danger',
        text: 'Customer no encontrado',
        duration: 4000,
      });
      return;
    }

    await axiosInstance
      .post('/approve_customer', {
        tn_id: tn_id,
      })
      .then((response) => {
        console.log(response);
        if (response.data.status) {
          const customer = pendingCustomers.find((c) => c.tn_id == tn_id);
          console.log('customer found to remove ? ', customer);
          setPendingCustomers(
            pendingCustomers.filter((customer) => {
              console.log('cusstomer id dif?? ' + (customer.tn_id !== tn_id));
              return customer.tn_id !== tn_id;
            }),
          );
          if (customer) setApprovedCustomers([...approvedCustomers, customer]);

          addToast({
            id: 'approve-customer-success',
            type: 'success',
            text: 'Customer aprobado!',
            duration: 4000,
          });
        }
      })
      .catch((e) => {
        addToast({
          id: 'approve-customer-fail',
          type: 'danger',
          text:
            e.response.data?.message ?? 'Error al tratar de aprobar el cliente',
          duration: 4000,
        });
        console.log(e);
      });
      */
  };

  /*
  const rejectSeller = async (store_id: any) => {
    console.log('reject seller store id : ' + store_id);
    const seller = pendingSellers.find((s) => s.store_id == store_id);

    await axiosInstance
      .post('/reject_seller', {
        store_id: store_id,
      })
      .then((response) => {
        console.log(response);
        if (response.data.status == true) {
          const seller = pendingSellers.find((s) => s.store_id == store_id);
          console.log('seller found to remove ? ', seller);
          setPendingSellers(
            pendingSellers.filter((seller) => {
              return seller.store_id !== store_id;
            }),
          );
          addToast({
            id: 'reject-seller-success',
            type: 'success',
            text: 'Seller rechazado',
            duration: 4000,
          });
        }
      })
      .catch((e) => {
        addToast({
          id: 'reject-seller-fail',
          type: 'danger',
          text:
            e.response.data?.message ?? 'Error al tratar de rechazar el seller',
          duration: 4000,
        });
        console.log(e);
      });
    return;
  };
  */

  /*
  const viewSellerProducts = async (store_id: any) => {
    console.log('view seller products store id : ' + store_id);
    //push('/config', { data: 'asd' });

    //push('/config?asd=8', 'asd');

    //history.pushState('asd', '', '/config');

    //push('/config', { 'asd ': 'as2d' });

    push({
      pathname: '/config?' + store_id,
      state: { data: store_id },
    });

  };
  */

  /*
  const viewCustomerData = async (tn_id: any) => {
    console.log('view customer data store for customer id ' + tn_id);

    push({
      pathname: '/data?asd=333',
      search: '?asd=888',
      state: { data: 'asd' },
    });
    
    push({
      pathname: '/data?' + tn_id,
      state: { data: tn_id },
    });
    
  };

  */

  const viewCustomerData = (tn_id: string) => {
    push(`/customer/${tn_id}`);
  };

  /*
  const viewSellerMetrics = async (store_id: any) => {
    console.log('view seller metrics store id : ' + store_id);
    push({
      pathname: '/metrics',
      search: '?asd=888',
      state: { data: 'asd' },
    });
    push({
      pathname: '/metrics?' + store_id,
      state: { data: store_id },
    });
  };
  */

  /*
  const checkVinculateAccount = async () => {
    console.log('checkeand vinculacion de cuenta...');
    try {
      const response = await axiosInstance.get('/check_status_account');
      console.log(response);
      if (response.data.status == true) {
        console.log('CUENTA YA VINCULADA');
        setIsVerifing(false);
        setIsVinculate(true);
      }
    } catch (e) {
      console.error(e);
      setIsVerifing(false);
      setIsVinculate(false);
    }
    return;
  };
  */

  /*
  const validateEmail = (email: string) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!emailRegex.test(email)) {
      setError(true);
      return false;
    } else {
      setError(false);
      return true;
    }
  };
  */

  /*
  const handleChangeSellerTag = (e: any) => {
    console.log(e.target.value, ' - ', e.target.id);
    const seller = pendingSellers.find((s) => s.store_id == e.target.id);
    if (seller) seller.seller_tag = e.target.value;
  };
  */

  const actions = (
    <Box display="none" gap="4">
      <Button onClick={handleGoToRejected} appearance="danger">
        Ver rechazados/desinstalados
      </Button>
    </Box>
  );

  if (isVerifing)
    return (
      <div>
        <label>Verificando vinculación...</label>
      </div>
    );

  return (
    <Page maxWidth="1500px" marginTop="18">
      {!isVerifing && isVinculate ? (
        <>
          <Page.Header
            alignItems="center"
            title="Tu cuenta ya está vinculada y activa"
          />
          <Box display="flex" gap="4" justifyContent="center">
            <Button appearance="primary" onClick={handleGoToConfig}>
              <Icon source={<CogIcon />} color="currentColor" />
              Ir a configuración
            </Button>
          </Box>
        </>
      ) : (
        <>
          <Page.Header title="Clientes" buttonStack={actions} />
          <Page.Body>
            <Layout columns="1">
              <Layout.Section>
                <Box display="flex" flexDirection="column" gap="4" padding="4">
                  <Title textAlign="center" as="h3">
                    Lista de clientes activos
                  </Title>
                  <Box display="inline-flex" gap="2" maxWidth="200px">
                    <Text as="span">Filtrar: </Text>
                    <Input
                      name="filtro_pendientes"
                      type="text"
                      placeholder=""
                      onChange={(event) => {
                        handleFilterAprobados(event);
                      }}
                    />
                  </Box>
                </Box>
                <Table>
                  <Table.Head>
                    {headersAprobados.map((header) => (
                      <Table.Cell key={header}>{header}</Table.Cell>
                    ))}
                  </Table.Head>
                  <Table.Body>
                    {approvedCustomers.map((customer) => (
                      <Table.Row key={customer.tn_id}>
                        <Table.Cell>{customer.tn_id}</Table.Cell>
                        <Table.Cell>{customer.name}</Table.Cell>
                        <Table.Cell>
                          <a
                            href={
                              'https://tiendanubelerendemo6.mitiendanube.com/admin/v2/customers/' +
                              customer.tn_id
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            Ver cliente
                          </a>
                        </Table.Cell>
                        <Table.Cell>{customer.email}</Table.Cell>
                        <Table.Cell>{customer.phone}</Table.Cell>
                        <Table.Cell>{customer.tn_created_at ?? ''}</Table.Cell>
                        <Table.Cell>
                          <Button
                            onClick={() => viewCustomerData(customer.tn_id)}
                            appearance="primary"
                          >
                            Ver datos
                          </Button>
                        </Table.Cell>
                        <Table.Cell>
                          <Button
                            onClick={() => makeInactiveCustomer(customer.tn_id)}
                            appearance="primary"
                          >
                            Inactivar
                          </Button>
                        </Table.Cell>
                        {/*
                        <Table.Cell>
                          <Button
                            onClick={() => rejectSeller(seller.store_id)}
                            appearance="danger"
                          >
                            Rechazar
                          </Button>
                        </Table.Cell>
                        */}
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
                <Box
                  display="flex"
                  justifyContent="center"
                  mt="4"
                  gap="2"
                  alignItems="center"
                >
                  {Array.from(
                    { length: lastApprovedCustomerPage },
                    (_, index) => {
                      const page = index + 1;
                      return (
                        <Button
                          key={page}
                          appearance={
                            page === currentApprovedCustomerPage
                              ? 'primary'
                              : 'neutral'
                          }
                          onClick={() => setCurrentApprovedCustomerPage(page)}
                        >
                          {page}
                        </Button>
                      );
                    },
                  )}
                </Box>
                <Box display="flex" flexDirection="column" gap="4" padding="4">
                  <Title textAlign="center" as="h3">
                    Lista de clientes inactivos
                  </Title>
                  <Box display="inline-flex" gap="2" maxWidth="200px">
                    <Text as="span">Filtrar: </Text>
                    <Input
                      name="filtro_aprobados"
                      type="text"
                      placeholder=""
                      onChange={(event) => {
                        handleFilterInactive(event);
                      }}
                    />
                  </Box>
                </Box>
                <Table>
                  <Table.Head>
                    {headersInactivos.map((header) => (
                      <Table.Cell key={header}>{header}</Table.Cell>
                    ))}
                  </Table.Head>
                  <Table.Body>
                    {inactiveCustomers.map((customer) => (
                      <Table.Row key={customer.tn_id}>
                        <Table.Cell>{customer.tn_id}</Table.Cell>
                        <Table.Cell>{customer.name}</Table.Cell>
                        <Table.Cell>
                          <a
                            href={
                              'https://tiendanubelerendemo6.mitiendanube.com/admin/v2/customers/' +
                              customer.tn_id
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            Ver cliente
                          </a>
                        </Table.Cell>
                        <Table.Cell>{customer.email}</Table.Cell>
                        <Table.Cell>{customer.phone}</Table.Cell>
                        <Table.Cell>{customer.approved_at ?? ''}</Table.Cell>
                        <Table.Cell>
                          <Button
                            onClick={() => viewCustomerData(customer.tn_id)}
                            appearance="primary"
                          >
                            Ver datos
                          </Button>
                        </Table.Cell>
                        {/*
                        <Table.Cell>
                          <Button
                            onClick={() => viewSellerProducts(seller.store_id)}
                            appearance="primary"
                          >
                            Ver productos
                          </Button>
                        </Table.Cell>
                        <Table.Cell>
                          <Button
                            onClick={() => viewSellerMetrics(seller.store_id)}
                            appearance="primary"
                          >
                            Ver metricas
                          </Button>
                        </Table.Cell>
                        */}
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              </Layout.Section>
            </Layout>
          </Page.Body>
        </>
      )}
    </Page>
  );
};

export default SetupPage;
